import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiInbox } from 'react-icons/fi';
import { FaRegPenToSquare } from "react-icons/fa6";
import { IoLockClosedOutline } from "react-icons/io5";
import { CustomerCenterService } from "../../../services";
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import { formatDateToYYYYMMDD } from '../../../utils/dateUtils';
import NewBadge from '../../../assets/img/customer-service-center/new.png';
import Pagination from '../../../components/Pagination/Pagination';
import CustomPagination from '../../../components/Pagination/CustomPagination';

const ContactUs = () => {
  const navigate = useNavigate();
  const [boardList, setBoardList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPages, setTotalPages] = useState(10); // Assuming 10 pages for now

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchInquiryData = async (page = currentPage, append = false) => {
    try {
      setLoading(true);
      const apiData = await CustomerCenterService.getInquiryList({
        page: page,
        size: 10,
        type: selectedFilter,
        keyword: searchQuery,
      });
      if (append) {
        setBoardList([...boardList, ...apiData.content]);
      } else {
        setBoardList(apiData.content.length > 0 ? apiData.content : []);
      }
      setTotalPages(apiData.totalPages);
    } catch (err) {
      console.error('Failed to fetch Inquiry:', err);
      setBoardList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInquiryData(currentPage, false);
  }, []);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchInquiryData(1, false);
  };

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected + 1);
    fetchInquiryData(selectedItem.selected + 1, false);
  };

  const handleLoadMore = () => {
    setCurrentPage(currentPage + 1);
    fetchInquiryData(currentPage + 1, true);
  };

  const handleWritePost = () => {
    navigate('/contact-us-writing');
  };

  const handleInquiryClick = (id, secretFlag) => {
    if (secretFlag === 'Y') {
      navigate(`/contact-secret-post/${id}`);
    } else {
      navigate(`/inquiry-details/${id}`);
    }
  };

  return (
    // <>
    //   <div className="announcement-list-page">
    //     <TopSetion />

    //     {/* Main Content */}
    //     <main className="main-content">
    //       <SubHeading heading="문의하기" />

    //       {/* FAQ Section */}
    //       <section className="contact-us-section">

    //         <div className="contact-us-inner">
    //           {/* Search and Filter Section */}
    //           <div className="search-filter-section">
    //             <div className="search-container">
    //               <select
    //                 className="filter-dropdown"
    //                 value={selectedFilter}
    //                 onChange={(e) => setSelectedFilter(e.target.value)}
    //               >
    //                 <option value="">전체</option>
    //                 <option value="title">제목</option>
    //                 <option value="detail">내용</option>
    //                 <option value="author">글쓴이</option>
    //                 <option value="title+content">제목+내용</option>
    //               </select>

    //               <input
    //                 type="text"
    //                 className="search-input"
    //                 placeholder="Search"
    //                 value={searchQuery}
    //                 onChange={(e) => setSearchQuery(e.target.value)}
    //               />

    //               <button className="search-button" onClick={handleSearch}>
    //                 검색
    //               </button>
    //             </div>
    //           </div>

    //           {/* Board List Section */}
    //           <div className="board-list-section">

    //             {boardList.length === 0 ? (
    //               <div className="empty-state">
    //                 <FiInbox className="empty-icon" size={64} />
    //                 <div className="empty-title">등록된 문의사항이 없습니다</div>
    //                 <div className="empty-description">
    //                   새로운 문의사항이 등록되면 이곳에 표시됩니다.
    //                 </div>
    //               </div>
    //             ) : (
    //               <>
    //                 {/* Board Items */}
    //                 {boardList.map((item, index) => (
    //                   <div key={item.contentId} className="board-item">
    //                     <div className="item-number">{item.contentId}</div>
    //                     <div className="item-title" onClick={() => handleInquiryClick(item.boardId, item.secretFlag)}>
    //                       {item.title}
    //                       {item.secretFlag === 'Y' && <div className="lock-icon"><IoLockClosedOutline size={16} /></div>}
    //                       {index === 0 && currentPage === 1 && <span className="new-badge"><img src={NewBadge} alt="New" /></span>}
    //                     </div>
    //                     <div className="item-author">{item.writerName}</div>
    //                     <div className="item-date">{formatDateToYYYYMMDD(item.registTime)}</div>
    //                     <div className="item-status">
    //                       <div className={`status-icon ${item.adminResponseFlag}`}>
    //                         {item.adminResponseFlag === 'N' ? 'X' : '✓'}
    //                       </div>
    //                     </div>
    //                   </div>
    //                 ))}
    //               </>
    //             )}
    //           </div>


    //           {/* {boardList.length > 0 && (
    //             <Pagination totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} />
    //           )} */}

    //           {boardList.length > 0 && (
    //             <CustomPagination totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} />
    //           )}

    //           {/* Load More Button */}
    //           {currentPage < totalPages && (
    //             <div className="more-button-section">
    //               <button
    //                 className="more-button"
    //                 onClick={handleLoadMore}
    //               >
    //                 더보기
    //               </button>
    //             </div>
    //           )}

    //           {/* Bottom Action Section */}
    //           <div className="bottom-action-section">
    //             <div className="write-container">
    //               <div className="write-icon"><FaRegPenToSquare size={18} /></div>
    //               <label htmlFor="inquiry-notice">
    //                 궁금하신 점이 있으시면 문의글을 남겨주세요!
    //               </label>
    //             </div>

    //             <button className="write-button" onClick={handleWritePost}>
    //               글쓰기
    //             </button>
    //           </div>
    //         </div>
    //       </section>
    //     </main>
    //   </div>
    // </>

    <div className="announcement-list-page">
      <TopSetion />

      <main className="main-content">
        <SubHeading heading="문의하기" />

        <section className="contact-us-section">
          <div className="contact-us-inner">

            {/* Search and Filter Section */}
            <div className="search-filter-section">
              <div className="search-container">
                <select
                  className="filter-dropdown"
                  value={selectedFilter}
                  onChange={(e) => setSelectedFilter(e.target.value)}
                >
                  <option value="">전체</option>
                  <option value="title">제목</option>
                  <option value="detail">내용</option>
                  <option value="author">글쓴이</option>
                  <option value="title+content">제목+내용</option>
                </select>

                <input
                  type="text"
                  className="search-input"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />

                <button className="search-button" onClick={handleSearch}>
                  검색
                </button>
              </div>
            </div>

            {/* Board List Section */}
            <div className="board-list-section">
              {loading && boardList.length === 0 ? (
                <div className="loading-container">
                  <div className="loading-spinner"></div>
                  <p>문의사항을 불러오는 중...</p>
                </div>
              ) : boardList.length === 0 ? (
                <div className="empty-state">
                  <FiInbox className="empty-icon" size={64} />
                  <div className="empty-title">등록된 문의사항이 없습니다</div>
                  <div className="empty-description">
                    새로운 문의사항이 등록되면 이곳에 표시됩니다.
                  </div>
                </div>
              ) : isMobile ? (
                // Mobile Design
                boardList.map((item, index) => (
                  <div key={item.contentId} className="memorial-post-board-list">
                    <div className="list-number">{item.contentId}</div>

                    <div
                      className="list-content"
                      onClick={() => handleInquiryClick(item.boardId, item.secretFlag)}
                    >
                      <div className="list-title">
                        <span className="title-text">{item.title}</span>
                        {item.secretFlag === "Y" && (
                          <span className="lock-icon">
                            <IoLockClosedOutline size={16} />
                          </span>
                        )}
                        {index === 0 && currentPage === 1 && (
                          <span className="new-badge">
                            <img src={NewBadge} alt="New" />
                          </span>
                        )}
                      </div>

                      <div className="list-meta">
                        <span className="list-author">{item.writerName}</span>
                        <span className="meta-separator">|</span>
                        <span className="list-date">
                          {formatDateToYYYYMMDD(item.registTime)}
                        </span>
                      </div>
                    </div>

                    <div className="list-status">
                      <div
                        className={`status-icon ${item.adminResponseFlag === "N" ? "status-x" : "status-check"
                          }`}
                      >
                        {item.adminResponseFlag === "N" ? "X" : "✓"}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                // Desktop Design
                boardList.map((item, index) => (
                  <div key={item.contentId} className="board-item">
                    <div className="item-number">{item.contentId}</div>
                    <div
                      className="item-title"
                      onClick={() => handleInquiryClick(item.boardId, item.secretFlag)}
                    >
                      {item.title}
                      {item.secretFlag === "Y" && (
                        <div className="lock-icon">
                          <IoLockClosedOutline size={16} />
                        </div>
                      )}
                      {index === 0 && currentPage === 1 && (
                        <span className="new-badge">
                          <img src={NewBadge} alt="New" />
                        </span>
                      )}
                    </div>
                    <div className="item-author">{item.writerName}</div>
                    <div className="item-date">{formatDateToYYYYMMDD(item.registTime)}</div>
                    <div className="item-status">
                      <div className={`status-icon ${item.adminResponseFlag}`}>
                        {item.adminResponseFlag === "N" ? "X" : "✓"}
                      </div>
                    </div>
                  </div>
                ))
              )}

            </div>
            {/* {boardList.length > 0 && (
    //             <Pagination totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} />
    //           )} */}
            {/* Pagination */}
            {boardList.length > 0 && (
              <CustomPagination
                totalPages={totalPages}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
              />
            )}

            {/* Load More Button */}
            {currentPage < totalPages && (
              <div className="more-button-section">
                <button className="more-button" onClick={handleLoadMore}>
                  더보기
                </button>
              </div>
            )}

            {/* Bottom Action Section */}
            <div className="bottom-action-section">
              <div className="write-container">
                <div className="write-icon"><FaRegPenToSquare size={18} /></div>
                <label htmlFor="inquiry-notice">
                  궁금하신 점이 있으시면 문의글을 남겨주세요!
                </label>
              </div>

              <button className="write-button" onClick={handleWritePost}>
                글쓰기
              </button>
            </div>

          </div>
        </section>
      </main>
    </div>
  );
};

export default ContactUs;